import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { useTranslationApp } from "../../../../../lib/i18next";
import Select from "../../../../../components/Form/Select";
import SelectBusinessAccount from "../../../../../components/Meta/SelectBusinessAccount";
import SelectMerchantGoogle from "../../../../../components/Platforms/Google/Campaign/SelectMerchantGoogle";
import SelectGoogleApp from "../../../../../components/Platforms/Google/Campaign/SelectGoogleApp";
import Typography from "@mui/material/Typography";
import { optionsCampaignsTypeGoogleAds } from "../../../../../utils/options";
import {
  APPLE_APP_STORE,
  GOOGLE,
  GOOGLE_APP_STORE,
} from "../../../../../utils/constants";
import {
  AD_ACCOUNT_GOOGLE_PLACEHOLDER,
  APP_PLACEHOLDER,
  APP_STORE_ANDROID,
  APP_STORE_IOS,
  APP_STORE_PLACEHOLDER,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_APP_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CAMPAIGN_TYPE_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_IDENTITIES_ACCOUNTS_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_MERCHANT_ID_LABEL,
  MERCHANT_CENTER_ID_PLACEHOLDER,
  SELECT_A_OPTION,
} from "../../../../../i18n/keysTranslations";
import { getGoogleDefaultsFieldVisibility } from "../../../../../utils/platformDefaults/platformDefaultsFieldVisibility";
import { PLATFORM_DEFAULTS_FIELD_LABEL_SX } from "../../../../../utils/platformDefaults/platformDefaultsFieldLabelSx";

const PlatformDefaultsFormGoogle = ({ formMethods }) => {
  const { t } = useTranslationApp();
  const { control, setValue, watch, formState } = formMethods;

  const objective = watch("objective");
  const integrationID = watch("integrationID");
  const adAccountID = watch("adAccountID");
  const appStore = watch("appStore");
  const errors = formState?.errors || {};

  const visibility = getGoogleDefaultsFieldVisibility({ objective });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {visibility.objective ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography variant="body2" sx={PLATFORM_DEFAULTS_FIELD_LABEL_SX}>
            {t(CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CAMPAIGN_TYPE_LABEL)}
          </Typography>
          <Select
            options={optionsCampaignsTypeGoogleAds}
            name="objective"
            variant="filled"
            fullWidth
            label={t(SELECT_A_OPTION)}
            doTranslate={true}
            control={control}
          />
        </Box>
      ) : null}

      {visibility.identities ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography variant="body2" sx={PLATFORM_DEFAULTS_FIELD_LABEL_SX}>
            {t(CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_IDENTITIES_ACCOUNTS_LABEL)}
          </Typography>
          <SelectBusinessAccount
            variant="filled"
            label={t(AD_ACCOUNT_GOOGLE_PLACEHOLDER)}
            control={control}
            platform={GOOGLE}
            name="adAccountID"
            onChangeAction={(value) => {
              setValue("integrationID", value?.integrationID);
              setValue("merchantCenterID", "");
            }}
            fullWidth={true}
          />
        </Box>
      ) : null}

      {visibility.merchantCenterID ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography variant="body2" sx={PLATFORM_DEFAULTS_FIELD_LABEL_SX}>
            {t(CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_MERCHANT_ID_LABEL)}
          </Typography>
          <SelectMerchantGoogle
            label={t(MERCHANT_CENTER_ID_PLACEHOLDER)}
            name="merchantCenterID"
            control={control}
            variant="filled"
            fullWidth
            integrationID={integrationID}
            adAccountID={adAccountID}
          />
        </Box>
      ) : null}

      {visibility.appID ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography variant="body2" sx={PLATFORM_DEFAULTS_FIELD_LABEL_SX}>
            {t(CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_APP_LABEL)}
          </Typography>
          <FormControl component="fieldset">
            <FormLabel component="legend">{t(APP_STORE_PLACEHOLDER)}</FormLabel>
            <RadioGroup
              row
              value={appStore || ""}
              onChange={(e) => {
                setValue("appStore", e.target.value);
                setValue("appID", "");
              }}
            >
              <FormControlLabel
                value={GOOGLE_APP_STORE}
                control={<Radio />}
                label={t(APP_STORE_ANDROID)}
              />
              <FormControlLabel
                value={APPLE_APP_STORE}
                control={<Radio />}
                label={t(APP_STORE_IOS)}
              />
            </RadioGroup>
          </FormControl>
          {appStore ? (
            <SelectGoogleApp
              control={control}
              errors={errors}
              name="appID"
              label={t(APP_PLACEHOLDER)}
              store={appStore}
              fullWidth
              variant="filled"
              placeholder={t(APP_PLACEHOLDER)}
            />
          ) : null}
        </Box>
      ) : null}
    </Box>
  );
};

export default PlatformDefaultsFormGoogle;
